import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AppConstant } from '../constants/app-constant';
import { TenantProvider } from '../providers/tenant.provider';
import { DEAccessCheckerService } from '../services/access-checker.service';

@Injectable()
export class AccessGuard implements CanActivate {

  constructor(private router: Router, private deAccessCheckerService: DEAccessCheckerService, private tenantProvider: TenantProvider) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.deAccessCheckerService.isGranted('view', state.url).pipe(tap(res => {

      if (!res)
        this.router.navigate(['']);
      return res;
    }));
  }
}
